import React from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';

import './App.css';

function HomePlusTermsPage() {
  const { termId } = useParams();

  return (
    <main className="main-content">
      <h4>Your reference:</h4>
      <h2>{termId}</h2>
      <br></br>
      <p>We have received an instruction from your mortgage provider to provide a HomePlus Survey Report.</p>
      <p>Please read the all the terms and conditions carefully, before completing and submitting the acceptance form.</p>
      <p>All documentation is available to download from the <strong>Your Documents</strong> section of the menu.</p>
      <Link to={`/homeplus-terms-accept/${termId}`} className="link-button">Continue</Link>
    </main>
  );
}

export default HomePlusTermsPage;
